/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {
  getUniversalTrackerValueLatestAttribute,
  UtrAttribute,
  UtrLookup
} from './index';
import { ActionCreator } from '@reduxjs/toolkit';
import { UtrValueFields, UtrvDataState, ValueData } from '@g17eco/types/universalTrackerValue';
import { MinimalUtrv } from '@features/universal-tracker-value';

export type Value = string | number | ValueData | UtrValueFields | undefined | UtrvDataState | MinimalUtrv;

export const getActual = (universalTracker: UtrLookup, attribute: UtrAttribute = null): ActionCreator<Value> => {
  return (dispatch, getState) => {
    const actual = getUniversalTrackerValueLatestAttribute(
      getState(),
      universalTracker,
      'actual',
      attribute
    );
    return actual || dispatch(getBaseline(universalTracker, attribute));
  };
};

export const getTarget = (universalTracker: UtrLookup, attribute: UtrAttribute = null): ActionCreator<Value> => {
  return (dispatch, getState) => {
    return getUniversalTrackerValueLatestAttribute(
      getState(),
      universalTracker,
      'target',
      attribute,
    );
  };
};

export const getBaseline = (universalTracker: UtrLookup, attribute: UtrAttribute = null): ActionCreator<Value> => {
  return (dispatch, getState) => {
    return getUniversalTrackerValueLatestAttribute(
      getState(),
      universalTracker,
      'baseline',
      attribute,
    );
  };
};
